import { render, staticRenderFns } from "./CostumersIndex.vue?vue&type=template&id=a8d59a6e"
import script from "./CostumersIndex.vue?vue&type=script&lang=js"
export * from "./CostumersIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports